import type React from "react";
import { Route, Routes } from "react-router-dom";
// 学習ギルド
import HomePage from "../pages/site/HomePage/HomePage";
import AboutPage from "../pages/site/AboutPage/AboutPage";
import LoginPage from "../pages/site/LoginPage/LoginPage";
import SignupPage from "../pages/site/SignupPage/SignupPage";
import EventReportPage from "../pages/site/EventReportPage/EventReportPage";
import FAQPage from "../pages/site/FAQPage/FAQPage";
import ContactPage from "../pages/site/ContactPage/ContactPage";
// もくもく会
import MokumokuTopPage from "../pages/site/mokumoku/MokumokuTopPage/MokumokuTopPage";
import MokumokuSchedulePage from "../pages/site/mokumoku/SchedulePage/SchedulePage";
import MokumokuEventReportPage from "../pages/site/mokumoku/EventReportPage/EventReportPage";
import MokumokuFAQPage from "../pages/site/mokumoku/FAQPage/FAQPage";
// 勉強会
import StudyGroupsPage from "../pages/site/StudyGroupsPage/StudyGroupsPage";
// ハッカソン
import HackathonPage from "../pages/site/HackathonPage/HackathonPage";
// 利用規約
import TermsPage from "../pages/site/TermsPage/TermsPage";
// プライバシーポリシー
import PrivacyPolicyPage from "../pages/site/PrivacyPolicyPage/PrivacyPolicyPage";

// 認証
import AuthCallbackPage from "../pages/auth/AuthCallbackPage";

const SiteRoutes: React.FC = () => {
	return (
		<Routes>
			{/* 学習ギルド */}
			<Route path="" element={<HomePage />} />
			<Route path="about" element={<AboutPage />} />
			<Route path="event-report" element={<EventReportPage />} />
			<Route path="faq" element={<FAQPage />} />
			<Route path="contact" element={<ContactPage />} />
			<Route path="login" element={<LoginPage />} />
			<Route path="signup" element={<SignupPage />} />

			{/* もくもく会 */}
			<Route path="mokumoku">
				<Route path="" element={<MokumokuTopPage />} />
				<Route path="schedule" element={<MokumokuSchedulePage />} />
				<Route path="event-report" element={<MokumokuEventReportPage />} />
				<Route path="faq" element={<MokumokuFAQPage />} />
			</Route>

			{/* 勉強会 */}
			<Route path="study-groups">
				<Route path="" element={<StudyGroupsPage />} />
			</Route>

			{/* ハッカソン */}
			<Route path="hackathons">
				<Route path="" element={<HackathonPage />} />
			</Route>

			{/* 利用規約 */}
			<Route path="terms" element={<TermsPage />} />

			{/* プライバシーポリシー */}
			<Route path="privacy-policy" element={<PrivacyPolicyPage />} />

			{/* 認証 */}
			<Route path="/auth/callback" element={<AuthCallbackPage />} />
		</Routes>
	);
};

export default SiteRoutes;
